// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerStyles } from "@awc/Overrides/Widgets/MyListsDetails/MyListsDetailsHeader";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, iconLinkCommonStyles, mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import Plus from "@insite/mobius/Icons/Plus";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

const textSharedStyle = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.xSmall,
};

headerStyles.sharingStatus = {
    statusText: {
        size: fontConfig.fontSize.singleLineRegular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            & > span {
                display: flex;
            }
        `,
    },
    privateTooltip: {
        iconProps: {
            size: 16,
        },
        cssOverrides: {
            tooltipContainer: css`
                margin-left: -200px;
                &::after {
                    margin-left: 85px;
                }
                ${xScreen("lte", "sm")} {
                    margin-left: 0;
                }
            `,
        },
    },
};

headerStyles.totalText = {
    weight: fontConfig.weight.bold,
};

headerStyles.tagsSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

headerStyles.tagsTitle = {
    forwardAs: "p",
    weight: fontConfig.weight.bold,
    transform: "capitalize",
    ...textSharedStyle,
};

headerStyles.tagsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 12px 8px;
    `,
};

headerStyles.tag = {
    css: css`
        margin: 0;
        border-radius: 13px;
        padding: 4px 8px;
    `,
};

headerStyles.descriptionStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 18px;
        `,
    },
    heading: {
        css: css`
            display: none;
        `,
    },
    text: {
        forwardAs: "p",
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.xxSmall,
    },
};

headerStyles.lastUpdateText = {
    as: "p",
    size: fontConfig.fontSize.singleLineRegular,
    color: "text",
    css: css`
        opacity: 0.6;
    `,
};

headerStyles.totalLabel = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
    css: css`
        :after {
            content: ":";
        }
    `,
};

headerStyles.totalText = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
};

headerStyles.totalVatLabelText = {
    size: 12,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWithoutVatText = {
    weight: fontConfig.weight.bold,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWithoutVatLabelText = {
    size: 12,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWrapper = {
    css: css`
        display: flex;
        gap: 7px;
    `,
};

headerStyles.addListTagsLink = mergeWithCss(iconLinkCommonStyles(Plus), {
    icon: {
        iconProps: {
            css: css`
                opacity: 1;
                margin-left: 6px;
            `,
        },
    },
    css: css`
        ${IconWrapper}, ${TypographyStyle} {
            color: ${color("text.link")};
        }
        &&&:hover {
            ${IconWrapper}, ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
        }
    `,
});
